import { render, staticRenderFns } from "./AccountDisableRequestList.vue?vue&type=template&id=09cf3f9a&scoped=true&"
import script from "./AccountDisableRequestList.vue?vue&type=script&lang=js&"
export * from "./AccountDisableRequestList.vue?vue&type=script&lang=js&"
import style0 from "./AccountDisableRequestList.vue?vue&type=style&index=0&id=09cf3f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf3f9a",
  null
  
)

export default component.exports